import {DataFetcherRequest} from '@aboutyou/data-fetcher';
import {PRODUCTS_PER_PAGE} from '../constants';

interface Pagination {
  pagination?: {total: number};
  streamInfo?: {total: number};
}

type ProductStreamRequest<T extends Pagination> = (
  page: number,
) => DataFetcherRequest<T>;

const getTotalPages = (total?: number) => {
  return Math.ceil((total ?? 0) / PRODUCTS_PER_PAGE);
};

export const useProductStreamStatus = <T extends Pagination>(
  currentPage: number,
  request: ProductStreamRequest<T>,
) => {
  return getProductStreamStatus(currentPage, request(currentPage));
};

const getProductStreamStatus = (
  currentPage: number,
  {
    data,
    error,
    isLoading,
  }: {
    data?: Pagination;
    error?: object | unknown;
    isLoading: boolean;
  },
) => {
  const isCurrentStreamPagePending = Boolean(isLoading || error);
  const totalPages = isCurrentStreamPagePending
    ? NaN
    : getTotalPages(data?.pagination?.total || data?.streamInfo?.total);

  const isStreamEmpty = totalPages === 0;
  const reachedEndOfMainStream = isStreamEmpty || totalPages === currentPage;
  const isNextPageReady =
    !isCurrentStreamPagePending && !reachedEndOfMainStream;

  return {
    isNextPageReady,
    isStreamEmpty,
    reachedEndOfMainStream,
    totalPages,
    data,
  };
};
